import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const unbookmarkObject = async (id: string) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.contentObjects.bookmark.delete(id));
